<template>
  <div
    data-testid="all-destinations-card"
    @click="emitOpenFiltersGrid"
    class="all-destinations-card pointer"
  >
    <!-- image -->
    <div class="center">
      <img :src="imagePolicy" :alt="image.altText" class="image" />
      <!-- text -->
      <div class="card--body">
        <h3 class="card--title">
          {{ name }}
        </h3>
        <div v-if="showCitiesLabel" class="card--subtitle">{{ numCities }} {{ label }}</div>
      </div>
      <!-- arrow -->
    </div>
    <div>
      <i class="icon-arrow-right xs red"></i>
    </div>
  </div>
</template>

<script>
import { defaultImage } from '../../infrastructure/Configuration'
export default {
  name: 'AllDestinationsCard',
  props: {
    name: {
      type: String,
      required: true
    },
    numCities: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    image: {
      type: Object,
      default: () => ({
        url: defaultImage(),
        altText: ''
      })
    }
  },
  methods: {
    emitOpenFiltersGrid() {
      this.$emit('openFiltersGrid')
    }
  },
  computed: {
    showCitiesLabel() {
      return this.numCities > 0
    },
    imagePolicy() {
      return `${this.image.url}?impolicy=Rounded`
    }
  }
}
</script>

<style scoped lang="scss">
.all-destinations-card {
  box-sizing: border-box;

  padding: 10px 20px 10px 10px;
  gap: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 264px;
  height: 85px;
  border: 1px solid var(--color-grey);
  border-radius: 10px;
  @media (max-width: media('mobile-l')) {
    width: 100%;
  }
}
.all-destinations-card:hover {
  border: 1px solid var(--color-red);
}
.center {
  display: flex;
  align-items: center;
}
.image {
  width: 55px;
  height: 55px;

  flex: none;
  order: 0;
  flex-grow: 0;

  border-radius: 50%;
}
.card {
  &--title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    color: var(--color-eclipse);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  &--subtitle {
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    margin-top: 2px;
    color: var(--color-grey-dark);
  }
  &--body {
    align-items: center;
    padding: 0 1.25rem;
  }
}
.red {
  color: var(--color-red);
}
.pointer {
  cursor: pointer;
}
</style>
